import { all, call, put, takeLatest } from 'redux-saga/effects';

import { landingAPIs } from 'apis/services/landing';
import { paths } from 'constants/endPoint';
import { loadingAction, snackbarAction } from 'redux/settings/action';
import { sendCustomGTMEvent } from 'utility/googleTagManager';

import { ActionTypeEnum } from '../ActionTypeEnum';

import { etmaRegistrationActionSuccess, etmaResendActionSuccess, sendSMSActionSuccess } from './action';

// sending sms
function* sendSMSRequest({ payload, meta }) {
	try {
		yield put(loadingAction({ form: true }));
		const response = yield call(landingAPIs.sendSMS, payload);
		yield put(sendSMSActionSuccess(response.data?.Content));
		yield put(
			snackbarAction({
				message: response.data?.Message,
				severity: 'success',
			}),
		);
		meta?.sst?.('');
		meta?.rsf?.();
		yield put(loadingAction({ form: false }));
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}

// etma registration
function* etmaRegistrationRequest({ payload, meta }) {
	try {
		yield put(loadingAction({ form: true }));
		const response = yield call(landingAPIs.etmaRegistration, payload);

		yield put(etmaRegistrationActionSuccess({ response: response.data.Content, form: payload }));

		if (response?.data?.Status === 200 && +response?.data?.Content?.EtmaCode === 200) {
			yield put(
				snackbarAction({
					message: response.data?.Content?.EtmaMessage,
					severity: 'success',
				}),
			);
			meta?.ng.push(paths['/otp']);

			yield call(sendCustomGTMEvent, {
				'event_name': 'Registration_Confirm',
				'event_category': 'Click',
				'event_action': 'MEDU Landing',
				'event_label': 'Registration Page Click on Confirm',
				'event_value': {
					'phone_number': payload.mobile,
					'national_code': payload.nationalCode,
					'birth_date': payload.birthDate,
					'postal_code': payload.zipCode,
					'bank_name': payload.bankId,
					'account_number': payload.accountNumber,
				},
			});

			yield put(loadingAction({ form: false }));
		}

		if (+response?.data?.Content?.EtmaCode === 412) {
			meta?.ng.push(paths['/failed']);
			//
			yield call(sendCustomGTMEvent, {
				'event_name': 'Snackbar_Error',
				'event_category': 'Error',
				'event_action': 'MEDU Landing',
				'event_label': response.data?.Content?.EtmaMessage,
				'event_value': null,
			});

			yield put(loadingAction({ form: false }));
		}

		if (response.data?.Status > 400) {
			yield put(
				snackbarAction({
					message: response.data?.Content?.EtmaMessage,
					severity: 'error',
					autoHideDuration: 4000,
				}),
			);

			yield call(sendCustomGTMEvent, {
				'event_name': 'Snackbar_Error',
				'event_category': 'Error',
				'event_action': 'MEDU Landing',
				'event_label': response.data?.Content?.EtmaMessage,
				'event_value': null,
			});
			yield put(loadingAction({ form: false }));
		}

		yield call(sendCustomGTMEvent, {
			'event_name': 'Registration_TryToConfirm',
			'event_category': 'Click',
			'event_action': 'MEDU Landing',
			'event_label': 'Registration Page Try to Confirm',
			'event_value': {
				'phone_number': payload.mobile,
				'national_code': payload.nationalCode,
				'birth_date': payload.birthDate,
				'postal_code': payload.zipCode,
				'bank_name': payload.bankId,
				'account_number': payload.accountNumber,
			},
		});
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}

// etma confirm
function* etmaConfirmRequest({ payload, meta }) {
	try {
		yield put(loadingAction({ form: true }));
		const response = yield call(landingAPIs.etmaRegistrationConfirm, payload);

		if (response?.data?.Status === 200 && +response?.data?.Content?.EtmaCode === 200) {
			meta?.ng.push(paths['/success']);

			yield put(
				snackbarAction({
					message: response.data?.Content?.EtmaMessage,
					severity: 'success',
				}),
			);

			yield put(loadingAction({ form: false }));
		}

		if (response.data?.Status > 400) {
			yield put(
				snackbarAction({
					message: response.data?.Content?.EtmaMessage,
					severity: 'error',
					autoHideDuration: 4000,
				}),
			);

			yield call(sendCustomGTMEvent, {
				'event_name': 'Snackbar_Error',
				'event_category': 'Error',
				'event_action': 'MEDU Landing',
				'event_label': response.data?.Content?.EtmaMessage,
				'event_value': null,
			});
			yield put(loadingAction({ form: false }));
		}
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}

// resend
function* etmaResendSMSRequest({ payload, meta }) {
	try {
		yield put(loadingAction({ form: true }));
		const response = yield call(landingAPIs.etmaRegistrationReSendSMS, payload);

		if (response?.data?.Status === 200 && +response?.data?.Content?.EtmaCode === 200) {
			yield put(etmaResendActionSuccess(response.data?.Content));
			yield put(
				snackbarAction({
					message: response.data?.Content?.EtmaMessage,
					severity: 'success',
				}),
			);

			yield put(loadingAction({ form: false }));
		}

		if (response.data?.Status > 400) {
			yield put(
				snackbarAction({
					message: response.data?.Content?.EtmaMessage,
					severity: 'error',
					autoHideDuration: 4000,
				}),
			);

			yield call(sendCustomGTMEvent, {
				'event_name': 'Snackbar_Error',
				'event_category': 'Error',
				'event_action': 'MEDU Landing',
				'event_label': response.data?.Content?.EtmaMessage,
				'event_value': null,
			});

			yield put(loadingAction({ form: false }));
		}
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}

export default function* landingSaga() {
	yield all([
		takeLatest(ActionTypeEnum.sendSMS_request_landing, sendSMSRequest),
		takeLatest(ActionTypeEnum.etma_registration_request_landing, etmaRegistrationRequest),
		takeLatest(ActionTypeEnum.etma_confirm_request_landing, etmaConfirmRequest),
		takeLatest(ActionTypeEnum.etma_resend_request_landing, etmaResendSMSRequest),
	]);
}
